export const arrayIncludesOneOf = <ArrayType = unknown>(parent: ArrayType[], oneOf: ArrayType[]): boolean => {
  const parentSet = new Set<ArrayType>(parent)
  return oneOf.some(oneOfItem => parentSet.has(oneOfItem))
}
